import React, { ReactNode } from 'react';

import { Container as CoreContainer } from '../../..';

import { StyledHeader } from './Header.styles';
import { HeaderProps } from './Header.types';

const Header = ({
  menuSlot,
  burgerMenuSlot,
  logoSlot,
  extraSlot,
  containerComponent: Container = CoreContainer,
  containerProps,
  handleMenuOpen,
  renderLink,
  componentClassname = 'header',
  customClassnames = '',
  customStyle = '',
}: HeaderProps) => {
  const withContainer = (children: ReactNode): ReactNode => {
    if (!!containerProps) {
      return <Container {...containerProps}>{children}</Container>;
    }
    return children;
  };

  return (
    <StyledHeader
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      hasContainerProps={!!containerProps}
    >
      {withContainer(
        <>
          {burgerMenuSlot && (
            <button
              className={`${componentClassname}__burger`}
              onClick={handleMenuOpen}
            >
              {burgerMenuSlot}
            </button>
          )}

          {logoSlot && (
            <div className={`${componentClassname}__logo`}>
              {renderLink ? (
                renderLink({
                  href: '/',
                  children: logoSlot,
                })
              ) : (
                <a href={'/'}>{logoSlot}</a>
              )}
            </div>
          )}

          {menuSlot && (
            <div className={`${componentClassname}__menu`}>{menuSlot}</div>
          )}

          {extraSlot && (
            <div className={`${componentClassname}__extra-slot`}>
              {extraSlot}
            </div>
          )}
        </>,
      )}
    </StyledHeader>
  );
};
Header.displayName = 'Header';

export default Header;
